<template>
  <img :src="src" class="map-object" :class="classList">
</template>

<script>
  import './building.scss'
  import './trees.scss'
  import './mobile.scss'

  export default {
    props: {
      src: { type: String },
      type: { type: String, defaut: 'generic' },
      mute: { type: Boolean, default: false },
      area: { type: Boolean, default: false },
      animated: { type: Boolean, default: false }
    },
    computed: {
      classList () {
        return {
          [`map-object--${this.type}`]: this.type,
          'map-object--mute': this.mute,
//          'map-object--area': this.area,
          'map-object--animated': this.animated,
        }
      }
    }
  }
</script>

<style lang="scss">
  .map-object {
    position: absolute;
    transform-origin: 50% 50%;

    visibility: hidden;
    transition: 0s visibility 1.5s;
  }

  .map-object--animated {
    transition: 0s visibility;
    visibility: visible;
  }

  .map-object--area {
    /*background: rgba(#fff, 0.2);*/
  }

  .map-object--mute {
    opacity: 0.5;
  }

  .map-object img {
    /*display: block;*/
  }
</style>
